import {t} from 'i18next';
import {Box, Typography} from '@mui/material';
import {getUTCDateTimeForDisplay} from '../../../../utils/utils';
import AurAnimatedCard from '../../../common/aur-animated-card/AurAnimatedCard';
import {ONLY_DATE_SHOW_FORMAT} from '../../../../constants/constants';
import {AurLightTooltip} from '../../../common/aur-light-tooltip/aur-light-tooltip';
import {ClientData} from './ClientViewTab';

const ClientCard: React.FC<ClientData> = ({
  name,
  clientCode,
  totalBranches,
  totalActiveProjects,
  lastProjectCreatedTime,
}) => {
  let lastProjectCreateOn = null;
  if (lastProjectCreatedTime && lastProjectCreatedTime !== '')
    lastProjectCreateOn = getUTCDateTimeForDisplay(
      lastProjectCreatedTime,
      ONLY_DATE_SHOW_FORMAT
    );
  return (
    <AurAnimatedCard>
      <Box className="grid-card">
        <Box className="grid-1">
          <Typography className="typo-text headline1_size">{name}</Typography>
          <Box className="d-inline-flex">
            <Typography className=" typo-text body3_size mist-1500">
              {t('common.clientId')}
            </Typography>

            <Typography className="typo-text toastMessageText_size mist-1500">
              &nbsp;{clientCode}
            </Typography>
          </Box>
        </Box>
        <Box className="grid-2">
          <Box>
            <Typography className="grid-2-heading">{totalBranches}</Typography>
            <Typography className="typo-text body3_size mist-700">
              {t('welcomeScreenMultiClient.branches')}
            </Typography>
          </Box>
          <Box>
            <Typography className="grid-2-heading">
              {totalActiveProjects}
            </Typography>
            <Typography className=" typo-text body3_size mist-700">
              {t('welcomeScreenMultiClient.activeProjects')}
            </Typography>
          </Box>
        </Box>
        <Box className="grid-3">
          <Typography className=" typo-text body3_size mist-700">
            {t('welcomeScreenMultiClient.lastProjectAddedOn')}
          </Typography>
          <AurLightTooltip
            title={lastProjectCreateOn ? t('common.yearMonthDate') : ''}
            placement="top-start"
          >
            <Typography className="typo-text subhead4_size mist-100">
              {lastProjectCreateOn ?? ''}
            </Typography>
          </AurLightTooltip>
        </Box>
      </Box>
    </AurAnimatedCard>
  );
};

export default ClientCard;
